import { ARE_ANY_PRODUCTS_BEING_FETCHED } from "./constants"

export default {
  [ARE_ANY_PRODUCTS_BEING_FETCHED](state) {
    return Boolean(state.products_being_fetched.length)
  }
}
